export enum PokerCategory {
  ALL = 'All',
  STUD = 'Stud',
  OMAHA = 'Omaha',
  HOLDEM = 'Holdem',
  DRAW = 'Draw',
  CHINESE = 'Chinese',
  MIXED = 'Mixed',
  CUSTOM = 'Custom',
}

export enum TableType {
  CASH = 'CASH',
  TOURNAMENT = 'TOURNAMENT',
  SNG = 'SNG',
}

export enum Currency {
  USDT = 'USDT',
}

export enum TableStatus {
  INITIALIZING = 'INITIALIZING',
  STOPPING = 'STOPPING',
  STOPPED = 'STOPPED',
  RUNNING = 'RUNNING',
  RESTARTING = 'RESTARTING',
}
